<template>
<div class="data-time-select">
  <div v-show="!showShortcuts" class="data-time-range">
    <el-date-picker
      v-model="query.beginTime"
      :picker-options="startDatePickerOptions"
      :clearable="clearable"
      :editable="false"
      placeholder="开始时间"
      type="date"
      format="yyyy年MM月dd日"
      value-format="yyyy/MM/dd 00:00:00"
      size="small"
      style="width:170px;"
      @change="onDataTimeChanged('begin-time-change')"
    />
    <span>～</span>
    <el-date-picker
      v-model="query.endTime"
      :picker-options="endDatePickerOptions"
      :clearable="clearable"
      :editable="false"
      placeholder="结束时间"
      type="date"
      format="yyyy年MM月dd日"
      value-format="yyyy/MM/dd 23:59:59"
      size="small"
      style="width:170px;"
      @change="onDataTimeChanged('end-time-change')"
    />
  </div>

  <div v-show="showShortcuts" class="shortcuts">
    <el-button
      v-for="shortcut in shortcuts"
      :key="shortcut.value"
      :type="shortcutVal === shortcut.value ? 'primary' : 'default'"
      size="small"
      @click="onShortcutBtnClick(shortcut)"
    >{{shortcut.label}}</el-button>
  </div>

  <el-button v-if="isShowQuick" size="small" @click="onSwitchShortcutsBtnClick">{{showShortcuts ? '日期选择' : '快速选择'}}</el-button>
</div>
</template>

<script>
export default {
  name: 'DataTimeQuery',
  props: {
    query: {
      required: true,
      type: Object
    },
    clearable: {
      type: Boolean,
      default: false
    },
    isShowQuick: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    showShortcuts: false,
    shortcutVal: null
  }),
  computed: {
    queryTimeStep: () => 3,
    shortcuts: () => [{
      value: 0,
      endValue: 0,
      label: '今天'
    }, {
      value: 1,
      endValue: 1,
      label: '昨天'
    }, {
      value: 2,
      endValue: 0,
      label: '三天'
    }, {
      value: 6,
      endValue: 0,
      label: '一周'
    }, {
      value: 30,
      endValue: 0,
      label: '一月'
    }],
    startDatePickerOptions () {
      return {
        disabledDate: time => this.query.endTime && time.getTime() > new Date(this.query.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => this.query.beginTime && time.getTime() < new Date(this.query.beginTime)
      }
    }
  },
  methods: {
    onDataTimeChanged (eventName) {
      this.shortcutVal = null
      this.$emit(eventName)
    },
    onSwitchShortcutsBtnClick () {
      this.showShortcuts = !this.showShortcuts
    },
    onShortcutBtnClick (shortcut) {
      let {endValue, value} = shortcut
      let {query} = this
      let now = new Date()
      now.setDate(now.getDate() - endValue)
      query.endTime = now.format('YYYY/MM/DD 23:59:59')
      now.setDate(now.getDate() - (value - endValue))
      query.beginTime = now.format('YYYY/MM/DD 00:00:00')

      if (this.shortcutVal !== value) {
        this.shortcutVal = value
        this.$emit('data-time-change')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.data-time-select {
  display: flex;
  gap: 6px;

  .data-time-range {
    display: grid;
    grid-template-columns: 170px max-content 170px;
    grid-column-gap: .5em;
    align-items: center;

    > span {
      font-size: .7em;
    }
  }

  .shortcuts {
    display: flex;

    > .el-button {
      & + .el-button {
        margin-left: -1px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/Query/DataTimeQuery.vue